export default [
  {
    path: '/report/class-teaching',
    name: 'report-class-teaching',
    meta: { requiresAuth: true },
    component: () => import('@/pages/class-teaching/index.vue')
  }
]
